import branchCreateComponent from './branch.create.component';

let branchCreateModule = angular.module('branchcreate', [
  ])

  .component('branchcreate', branchCreateComponent)

  .name;

export default branchCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/branch/create/index.js